import React, { useState } from 'react';
import { useAuth } from '../AuthContext';
import api from '../api';

export default function Profile() {
  const { user, updateUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.employee?.name || '',
    email: user?.email || '',
    username: user?.username || '',
  });
  const [pwForm, setPwForm] = useState({ current: '', next: '', confirm: '' });
  const [msg, setMsg] = useState('');
  const [pwMsg, setPwMsg] = useState('');
  const [saving, setSaving] = useState(false);
  const [savingPw, setSavingPw] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      const res = await api.put('/auth/profile', form).then(r => r.data);
      updateUser(res.user);
      if (res.token) {
        localStorage.setItem('hrtrack_token', res.token);
      }
      setMsg('success');
    } catch (err) {
      setMsg(err.response?.data?.error || 'Failed to update profile');
    }
    setSaving(false);
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    if (pwForm.next !== pwForm.confirm) { setPwMsg('Passwords do not match'); return; }
    if (pwForm.next.length < 6) { setPwMsg('Password must be at least 6 characters'); return; }
    setSavingPw(true);
    setPwMsg('');
    try {
      await api.post('/auth/change-password', { current_password: pwForm.current, new_password: pwForm.next });
      setPwMsg('success');
      setPwForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      setPwMsg(err.response?.data?.error || 'Failed to change password');
    }
    setSavingPw(false);
  };

  const initials = (user?.employee?.name || user?.username || '?').slice(0, 2).toUpperCase();

  return (
    <div style={{ maxWidth: 560, margin: '0 auto', padding: '32px 16px' }}>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1e1b4b', marginBottom: 8 }}>My Profile</h1>
      <p style={{ color: '#64748b', marginBottom: 32 }}>Manage your account details and password.</p>

      {/* Avatar */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
        <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--primary)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', fontWeight: 700 }}>
          {initials}
        </div>
        <div>
          <div style={{ fontWeight: 700, fontSize: '1.1rem', color: '#1e1b4b' }}>{user?.employee?.name || user?.username}</div>
          <div style={{ color: '#6366f1', fontSize: '0.85rem', textTransform: 'capitalize' }}>{user?.role}</div>
        </div>
      </div>

      {/* Profile form */}
      <div className="card" style={{ marginBottom: 24 }}>
        <div style={{ fontWeight: 700, fontSize: '1rem', color: '#1e1b4b', marginBottom: 20 }}>Account Information</div>
        <form onSubmit={handleSave}>
          {user?.employee_id && (
            <div className="form-group">
              <label>Full Name</label>
              <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Your full name" />
            </div>
          )}
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="your@email.com" />
          </div>
          <div className="form-group">
            <label>Username</label>
            <input value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} placeholder="username" />
          </div>

          {msg && (
            <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: '0.875rem',
              background: msg === 'success' ? '#f0fdf4' : '#fef2f2',
              color: msg === 'success' ? '#16a34a' : '#dc2626' }}>
              {msg === 'success' ? '✓ Profile updated successfully!' : msg}
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save Changes'}
          </button>
        </form>
      </div>

      {/* Password form */}
      <div className="card">
        <div style={{ fontWeight: 700, fontSize: '1rem', color: '#1e1b4b', marginBottom: 20 }}>Change Password</div>
        <form onSubmit={handlePasswordChange}>
          <div className="form-group">
            <label>Current Password</label>
            <input type="password" value={pwForm.current} onChange={e => setPwForm(f => ({ ...f, current: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input type="password" value={pwForm.next} onChange={e => setPwForm(f => ({ ...f, next: e.target.value }))} required />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input type="password" value={pwForm.confirm} onChange={e => setPwForm(f => ({ ...f, confirm: e.target.value }))} required />
          </div>

          {pwMsg && (
            <div style={{ padding: '10px 14px', borderRadius: 8, marginBottom: 12, fontSize: '0.875rem',
              background: pwMsg === 'success' ? '#f0fdf4' : '#fef2f2',
              color: pwMsg === 'success' ? '#16a34a' : '#dc2626' }}>
              {pwMsg === 'success' ? '✓ Password changed successfully!' : pwMsg}
            </div>
          )}

          <button type="submit" className="btn btn-primary" disabled={savingPw}>
            {savingPw ? 'Updating…' : 'Update Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
